import { DOCUMENT } from '@angular/common';
import { inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable, tap } from 'rxjs';
import { LOCALSTORAGE_TOKENS } from '../constants/injection-tokens';
import { Directions } from '../enums/directions.enum';
import { Languages } from '../enums/languages.enum';
import { LocalstorageTokensKeys } from '../../shared/models/tokens-keys.interface';
import { LocalStorageService } from './local-storage.service';

@Injectable({ providedIn: 'root' })
export class TranslationHelperService {
  private readonly translateService = inject(TranslateService);
  private readonly localStorageService = inject(LocalStorageService);
  private readonly document = inject(DOCUMENT);
  private readonly localstorageTokensKeys =
    inject<LocalstorageTokensKeys>(LOCALSTORAGE_TOKENS);
  private readonly enforcedLanguage = Languages.En;

  initLang(): Observable<unknown> {
    this.translateService.addLangs([Languages.Ar, Languages.En]);
    this.translateService.setFallbackLang(Languages.En);

    return this.useLang(this.enforcedLanguage);
  }

  changeLang(): void {
    this.useLang(this.enforcedLanguage).subscribe();
  }

  get getCurrentLanguage(): Languages {
    return this.enforcedLanguage;
  }

  translate(key: string, params?: Record<string, unknown>): string {
    return this.translateService.instant(key, params) as string;
  }

  private useLang(lang: Languages): Observable<unknown> {
    return this.translateService.use(lang).pipe(
      tap(() => {
        const htmlTag = this.document.documentElement;
        htmlTag.dir = lang === Languages.Ar ? Directions.rtl : Directions.ltr;
        htmlTag.lang = lang;
        this.localStorageService.setItem(this.localstorageTokensKeys.lang, lang);
      }),
    );
  }
}
